"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var defaultVariantMap = {
  h1: 'heading1',
  h2: 'heading2',
  h3: 'heading3',
  h4: 'heading4',
  h5: 'heading5',
  h6: 'heading6'
};

var Heading = function Heading(_ref) {
  var variant = _ref.variant,
      overflow = _ref.overflow,
      Element = _ref.as,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "overflow", "as"]);

  return (0, _themeUi.jsx)(Element, _extends({}, props, {
    sx: _extends({
      variant: "textStyles." + (variant || defaultVariantMap[Element])
    }, overflow === 'ellipsis' && {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    })
  }));
};

Heading.propTypes = {
  as: _propTypes["default"].oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']).isRequired,
  variant: _propTypes["default"].oneOf(['heading1', 'heading2', 'heading3', 'heading4', 'heading5', 'heading6', 'subtitle']),
  overflow: _propTypes["default"].oneOf(['ellipsis'])
};
var _default = Heading;
exports["default"] = _default;